export default [
  {
    path: "/executors",
    name: "executors",
    component: () => import("@/modules/executors/Executor.vue"),
    children: [
      {
        path: "list",
        name: "list-executors",
        component: () => import("@/modules/executors/pages/ExecutorList.vue"),
        meta: { permissions: ["executors-show"] }
      },
      {
        path: "add",
        name: "add-executors",
        component: () => import("@/modules/executors/pages/ExecutorAdd.vue"),
        meta: { permissions: ["executors-create"] }
      },
      {
        path: "edit/:id",
        name: "edit-executors",
        component: () => import("@/modules/executors/pages/ExecutorEdit.vue"),
        meta: { permissions: ["executors-update"] }
      }
    ]
  }
];
